import { IconSymbols } from "@flightpath/coreui/dist/generated/IconSymbols";
import { ButtonTypes } from "@flightpath/coreui/dist/ui/Button";
import { Icon } from "@flightpath/coreui/dist/ui/Icon";
import { Panel } from "../../../../../../components/ui/Panel";
import { ProjectProcessesGridModalView } from "../../../../../../pages/insight/projects/Processes/ProcessReportingView/modals/ProjectProcessesGridModal/ProjectProcessesGridModal_view";
import I18n from "../../../../../localization/I18n";
import ModalContext from "../../../../../modalZ/context/ModalContext";
import { WrapperActionGridWithDataLoader } from "../ActionsGrid/WrapperActionsGridWithDataLoader_view";

export const SHOW_CONFIRM_CREATION_MODAL = (name): Promise<boolean> => {
  return new Promise(async resolve => {
    await ModalContext.showConfirmDialog(
      <h1 className="mt-4">{I18n.t("phrases.confirm")}</h1>,
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-12">
            <Icon symbol={IconSymbols.AlertCircle} className="mr-2" />
            {I18n.t("warnings.createSameNameRow")}
          </div>
        </div>
        <div className="row">
          <div className="col">{I18n.t("warnings.confirmSameName", { name: name })}</div>
        </div>
      </div>,
      I18n.t("phrases.yes"),
      I18n.t("phrases.no"),
      {
        wrapWidth: "small",
        spacing: "small",
        position: "middle",
        panelProps: {
          background: Panel.PanelBackgrounds.BG_WHITE
        }
      },
      async () => {
        ModalContext.hide();
        resolve(true);
      },
      () => {
        ModalContext.hide();
        resolve(false);
      }
    );
  });
};

export const SHOW_TRAINING_MODULE_DELETE_CONFIRM_MODAL = (
  itemIds: number[],
  removeRange: (itemIds: number[]) => Promise<any>
) => {
  return new Promise(resolve => {
    ModalContext.showConfirmDialog(
      <h1 className="mt-4">{I18n.t("phrases.confirm")}</h1>,
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-12">
            <Icon symbol={IconSymbols.AlertCircle} className="mr-2" />
            {I18n.t("warnings.removeTrainingCourseFromProject")}
          </div>
        </div>
        <div className="row">
          <div className="col">{I18n.t("phrases.confirmTrainingCourseRangeRemove", { name: itemIds.length + "" })}</div>
        </div>
      </div>,
      I18n.t("phrases.yes"),
      I18n.t("phrases.no"),
      {
        wrapWidth: "small",
        spacing: "small",
        position: "middle",
        panelProps: {
          background: Panel.PanelBackgrounds.BG_WHITE
        }
      },
      async () => {
        ModalContext.hide();
        await removeRange(itemIds);
        resolve(true);
      },
      () => {
        ModalContext.hide();
      },
      ButtonTypes.DANGER
    );
  });
};

export const LINK_TO_ACTIONS_MODAL_CONFIG = (onAssignSuccess: (itemIds: number[]) => Promise<any>) => {
  return {
    showClose: false,
    title: null,
    className: "d-flex",
    panelProps: {
      className: "d-flex flex-column h-100"
    },
    content: <WrapperActionGridWithDataLoader onAssignSuccess={onAssignSuccess} />
  };
};

export const LINK_TO_PROCESSES_MODAL_CONFIG = (
  selectedLinkItems: number[],
  onAssignSuccess: (itemIds: number[]) => Promise<any>
) => {
  return {
    showClose: false,
    title: null,
    className: "d-flex flex-column",
    panelProps: {
      className: "d-flex flex-column h-100"
    },
    content: (
      <ProjectProcessesGridModalView
        preSelectedItemIds={selectedLinkItems}
        gridToolbarType="link-modal"
        onAssignSuccess={onAssignSuccess}
      />
    )
  };
};
